import { Service, ServiceTable } from "@/app/types/service";
import { ApiResponse } from "@/app/types/shared_types";
import { apiSlice } from "@/features/api/ApiSlice";
interface ServiceTags {
  id: number;
  name: string;
  tags: string[];
}

export const Services = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getServiceById: builder.query<Service, number>({
      query: (service_id) => ({
        url: `/service/${service_id}`,
        method: "GET",
        headers: {
          Accept: "application/json",
        },
      }),
      providesTags: (result, error, arg) => [{ type: "Service", id: arg }],
    }),
    getService: builder.query<ServiceTable, { query: string }>({
      query: ({ query }) => ({
        url: `/service${query ? "?" + query : ""}`,
        method: "GET",
        headers: {
          Accept: "application/json",
        },
      }),
      providesTags: ["Service"],
    }),
    getServiceTags: builder.query<ServiceTags, { serviceId: string; eventId?: number }>({
      query: ({ serviceId, eventId }) => ({
        url: `/service/${serviceId}/tags${eventId ? `?event_id=${eventId}` : ""}`,
        method: "GET",
        headers: {
          Accept: "application/json",
        },
      }),
      providesTags: ["Service"],
    }),
    createService: builder.mutation<ApiResponse, Service>({
      query: (servicedata) => ({
        url: "/service",
        method: "POST",
        body: servicedata,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }),
      invalidatesTags: ["Service"],
    }),
    updateService: builder.mutation<ApiResponse, Service>({
      query: (servicedata) => ({
        url: `/service/${servicedata.id}`,
        method: "PUT",
        body: servicedata,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }),
      invalidatesTags: ["Service"],
    }),
    deleteService: builder.mutation<ApiResponse, number>({
      query: (service_id) => ({
        url: `/service/${service_id}`,
        method: "DELETE",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }),
      invalidatesTags: ["Service"],
    }),
    updateThreshold: builder.mutation<void, number>({
      query: (number) => ({
        url: `/service/${number}/update_threshold`,
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }),
    }),
  }),
});

export const {
    useGetServiceQuery,
    useGetServiceByIdQuery,    
    useGetServiceTagsQuery,
    useLazyGetServiceTagsQuery,
    useCreateServiceMutation,
    useUpdateServiceMutation,
    useDeleteServiceMutation,
    useUpdateThresholdMutation
} = Services;
